import {
	EventApplicationListApiResponse,
	EventParticipantListApiResponse,
	EventParticipantFilter
} from "../context/EventApplicationContext/constants";
import { axiosInstance } from "../utils/axiosInstance";
import { getFileNameFromContentDisposition } from "../utils/downloadFile";

export interface ExcelDownload {
	blob: Blob;
	fileName: string;
}

const ENDPOINTS = {
	EVENT: "/cms/event",
};

export class EventApplicationService {
	static async getEventApplicationList(): Promise<EventApplicationListApiResponse> {	
		const response = await axiosInstance.get(`${ENDPOINTS.EVENT}/application`);
		return response.data;
	}

	static async getEventParticipantList(eventId: string): Promise<EventParticipantListApiResponse> {
		const response = await axiosInstance.get(`${ENDPOINTS.EVENT}/${eventId}/participant`);
		return response.data;
	}

	static async exportEventApplicationsExcel(): Promise<ExcelDownload> {
		const response = await axiosInstance.get(`${ENDPOINTS.EVENT}/application/excel`, {
			responseType: "blob",
		});
		return {
			blob: response.data,
			fileName: getFileNameFromContentDisposition(response.headers["content-disposition"], "Proje Başvuruları.xlsx"),
		};
	}

	static async exportEventParticipantExcel(eventId: string, filter: EventParticipantFilter): Promise<ExcelDownload> {
		const response = await axiosInstance.post(`${ENDPOINTS.EVENT}/${eventId}/participant/excel`, filter, {
			responseType: "blob",
		});
		return {
			blob: response.data,
			fileName: getFileNameFromContentDisposition(response.headers["content-disposition"], "Etkinlik Katılımcıları.xlsx"),
		};
	}
}